/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type AdvancedFinancialEligibilityCheckFragment = {
  __typename?: 'PatientFinancialEligibilityCheck'
  aperoEligibilityID: string
  coverageActive: boolean
  warnings?: Array<string> | null
  subscriber: {
    __typename?: 'PatientFinancialEligibilityCheckSubscriber'
    birthDate?: Date | null
    firstName: string
    groupDescription?: string | null
    groupNumber?: string | null
    id: string
    lastName: string
  }
}

export type GetAdvancedEligibilityLookupInputsQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedEligibilityLookupInputsQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    uid: string
    birthDate?: Date | null
    firstname?: string | null
    lastname?: string | null
    details?: Types.JSONObject | null
    credentialingHealthPlan?: string | null
    financialEligibilityCheck?: {
      __typename?: 'PatientFinancialEligibilityCheck'
      aperoEligibilityID: string
      coverageActive: boolean
      warnings?: Array<string> | null
      subscriber: {
        __typename?: 'PatientFinancialEligibilityCheckSubscriber'
        birthDate?: Date | null
        firstName: string
        groupDescription?: string | null
        groupNumber?: string | null
        id: string
        lastName: string
      }
    } | null
    costEstimateFailure?: { __typename?: 'PatientCostEstimateFailure'; reason: string } | null
  }
  sources: Array<{ __typename?: 'Source'; name: string }>
}

export type AdvancedFinancialEligibilityLookupMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  birthDate?: Types.InputMaybe<Types.Scalars['String']['input']>
  firstname?: Types.InputMaybe<Types.Scalars['String']['input']>
  lastname: Types.Scalars['String']['input']
  memberID?: Types.InputMaybe<Types.Scalars['String']['input']>
  groupNumber?: Types.InputMaybe<Types.Scalars['String']['input']>
  source: Types.Scalars['String']['input']
}>

export type AdvancedFinancialEligibilityLookupMutation = {
  __typename?: 'Mutation'
  financialEligibilityLookup: {
    __typename?: 'PatientFinancialEligibilityCheck'
    aperoEligibilityID: string
    coverageActive: boolean
    warnings?: Array<string> | null
    subscriber: {
      __typename?: 'PatientFinancialEligibilityCheckSubscriber'
      birthDate?: Date | null
      firstName: string
      groupDescription?: string | null
      groupNumber?: string | null
      id: string
      lastName: string
    }
  }
}

export type AdvancedCostEstimateLookupQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type AdvancedCostEstimateLookupQuery = {
  __typename?: 'Query'
  costEstimateLookup:
    | { __typename: 'CostEstimateLookupFailure'; reason: string }
    | {
        __typename: 'CostEstimateLookupSuccess'
        intakeCostEstimateInCents: number
        month1CostEstimateInCents: number
        month2CostEstimateInCents: number
        month3CostEstimateInCents: number
      }
}

export const AdvancedFinancialEligibilityCheckFragmentDoc = gql`
  fragment AdvancedFinancialEligibilityCheck on PatientFinancialEligibilityCheck {
    aperoEligibilityID
    coverageActive
    subscriber {
      birthDate
      firstName
      groupDescription
      groupNumber
      id
      lastName
    }
    warnings
  }
`
export const GetAdvancedEligibilityLookupInputsDocument = gql`
  query getAdvancedEligibilityLookupInputs($uid: ID!) {
    patient(uid: $uid) {
      uid
      birthDate
      firstname
      lastname
      details
      credentialingHealthPlan
      financialEligibilityCheck {
        ...AdvancedFinancialEligibilityCheck
      }
      costEstimateFailure {
        reason
      }
    }
    sources {
      name
    }
  }
  ${AdvancedFinancialEligibilityCheckFragmentDoc}
`

/**
 * __useGetAdvancedEligibilityLookupInputsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedEligibilityLookupInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedEligibilityLookupInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedEligibilityLookupInputsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedEligibilityLookupInputsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedEligibilityLookupInputsQuery,
    GetAdvancedEligibilityLookupInputsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedEligibilityLookupInputsQuery, GetAdvancedEligibilityLookupInputsQueryVariables>(
    GetAdvancedEligibilityLookupInputsDocument,
    options
  )
}
export function useGetAdvancedEligibilityLookupInputsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedEligibilityLookupInputsQuery,
    GetAdvancedEligibilityLookupInputsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedEligibilityLookupInputsQuery, GetAdvancedEligibilityLookupInputsQueryVariables>(
    GetAdvancedEligibilityLookupInputsDocument,
    options
  )
}
export type GetAdvancedEligibilityLookupInputsQueryHookResult = ReturnType<
  typeof useGetAdvancedEligibilityLookupInputsQuery
>
export type GetAdvancedEligibilityLookupInputsLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedEligibilityLookupInputsLazyQuery
>
export type GetAdvancedEligibilityLookupInputsQueryResult = Apollo.QueryResult<
  GetAdvancedEligibilityLookupInputsQuery,
  GetAdvancedEligibilityLookupInputsQueryVariables
>
export const AdvancedFinancialEligibilityLookupDocument = gql`
  mutation advancedFinancialEligibilityLookup(
    $uid: ID!
    $birthDate: String
    $firstname: String
    $lastname: String!
    $memberID: String
    $groupNumber: String
    $source: String!
  ) {
    financialEligibilityLookup(
      uid: $uid
      birthDate: $birthDate
      firstname: $firstname
      lastname: $lastname
      memberID: $memberID
      groupNumber: $groupNumber
      source: $source
    ) {
      ...AdvancedFinancialEligibilityCheck
    }
  }
  ${AdvancedFinancialEligibilityCheckFragmentDoc}
`
export type AdvancedFinancialEligibilityLookupMutationFn = Apollo.MutationFunction<
  AdvancedFinancialEligibilityLookupMutation,
  AdvancedFinancialEligibilityLookupMutationVariables
>

/**
 * __useAdvancedFinancialEligibilityLookupMutation__
 *
 * To run a mutation, you first call `useAdvancedFinancialEligibilityLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdvancedFinancialEligibilityLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [advancedFinancialEligibilityLookupMutation, { data, loading, error }] = useAdvancedFinancialEligibilityLookupMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      birthDate: // value for 'birthDate'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      memberID: // value for 'memberID'
 *      groupNumber: // value for 'groupNumber'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAdvancedFinancialEligibilityLookupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdvancedFinancialEligibilityLookupMutation,
    AdvancedFinancialEligibilityLookupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdvancedFinancialEligibilityLookupMutation,
    AdvancedFinancialEligibilityLookupMutationVariables
  >(AdvancedFinancialEligibilityLookupDocument, options)
}
export type AdvancedFinancialEligibilityLookupMutationHookResult = ReturnType<
  typeof useAdvancedFinancialEligibilityLookupMutation
>
export type AdvancedFinancialEligibilityLookupMutationResult =
  Apollo.MutationResult<AdvancedFinancialEligibilityLookupMutation>
export type AdvancedFinancialEligibilityLookupMutationOptions = Apollo.BaseMutationOptions<
  AdvancedFinancialEligibilityLookupMutation,
  AdvancedFinancialEligibilityLookupMutationVariables
>
export const AdvancedCostEstimateLookupDocument = gql`
  query advancedCostEstimateLookup($uid: ID!) {
    costEstimateLookup(uid: $uid) {
      __typename
      ... on CostEstimateLookupSuccess {
        intakeCostEstimateInCents
        month1CostEstimateInCents
        month2CostEstimateInCents
        month3CostEstimateInCents
      }
      ... on CostEstimateLookupFailure {
        reason
      }
    }
  }
`

/**
 * __useAdvancedCostEstimateLookupQuery__
 *
 * To run a query within a React component, call `useAdvancedCostEstimateLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedCostEstimateLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedCostEstimateLookupQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useAdvancedCostEstimateLookupQuery(
  baseOptions: Apollo.QueryHookOptions<AdvancedCostEstimateLookupQuery, AdvancedCostEstimateLookupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AdvancedCostEstimateLookupQuery, AdvancedCostEstimateLookupQueryVariables>(
    AdvancedCostEstimateLookupDocument,
    options
  )
}
export function useAdvancedCostEstimateLookupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdvancedCostEstimateLookupQuery, AdvancedCostEstimateLookupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AdvancedCostEstimateLookupQuery, AdvancedCostEstimateLookupQueryVariables>(
    AdvancedCostEstimateLookupDocument,
    options
  )
}
export type AdvancedCostEstimateLookupQueryHookResult = ReturnType<typeof useAdvancedCostEstimateLookupQuery>
export type AdvancedCostEstimateLookupLazyQueryHookResult = ReturnType<typeof useAdvancedCostEstimateLookupLazyQuery>
export type AdvancedCostEstimateLookupQueryResult = Apollo.QueryResult<
  AdvancedCostEstimateLookupQuery,
  AdvancedCostEstimateLookupQueryVariables
>
